import './_product-customizer-player.scss';
import component from './product-customizer-player.js';

export default component;
